import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import { NumberField } from '../../common/Inputs';
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { sms as smsType } from '../../../constants/settingTypes';

const validate = ({LimitSms}) => {

    const errors = {};
    if (parseFloat(LimitSms) <= 0 || !LimitSms)
    {
            errors.LimitSms = '*Ограничение не может быть меньше 1 смс';
    }
    return errors;
}

class EditModal extends React.Component {
    constructor(props) {
        
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    _onSubmit(values) {
        this.props.onSubmit(values);
    }
    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            pristine,
            crudError,
        } = this.props;
        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{'Настройка ограничений смс'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && (
                        <form className="form-horizontal">
                            <Field name="LimitSms" component={NumberField} label="Количество смс на один номер" />
                        </form>
                    )}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle="info">Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED && <Alert bsStyle="success">УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED && (
                        <Alert bsStyle="danger">
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                    )}
                </Modal.Body>
                {formVisible && (
                    <Modal.Footer>
                        <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>
                            Сохранить
                        </Button>
                        <Button type="button" onClick={onClose}>
                            Отмена
                        </Button>
                    </Modal.Footer>
                )}
                {closeButtonVisible && (
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        );
    }
}
EditModal = reduxForm({
    form: 'limitSms',
    validate,
})(EditModal);
EditModal = connect((state) => ({
    fetching: state.application.get('settings')[smsType].updateFetching,
    crudError: state.application.get('settings')[smsType].updateError,
}))(EditModal);
export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/smslimit/EditModal.jsx